import { ISmartFieldBlur } from "@components/smart/smartField/SmartField";
import {
    IPrRetirementSavingsCompanyEntity,
    PrRetirementSavingsCompanyEntity
} from "@odata/GeneratedEntityTypes";
import { getBankBlurArgs } from "@pages/banks/bankAccounts/BankAccounts.utils";
import { validateDataBox } from "@pages/payroll/healthInsuranceCompany/insuranceCompanies.utils";
import { handleBankAccountOrIBANBlur } from "@utils/BankUtils";
import { withPermissionContext } from "contexts/permissionContext/withPermissionContext";

import { FormViewForExtend } from "../../../views/formView/FormView";

class PrRetirementSavingsCompanyFormView extends FormViewForExtend<IPrRetirementSavingsCompanyEntity> {
    onAfterLoad(): Promise<void> {
        const { storage } = this.props;
        if (!storage.data.bindingContext.isNew()) {
            validateDataBox(storage);
        }

        return super.onAfterLoad();
    }

    handleBlur = async (args: ISmartFieldBlur): Promise<void> => {
        const { storage } = this.props;
        handleBankAccountOrIBANBlur(getBankBlurArgs(storage.getThis(), args.bindingContext));

        if (args.bindingContext.getPath() === PrRetirementSavingsCompanyEntity.DataBoxId) {
            await validateDataBox(this.props.storage);
        }


        await storage.handleBlur(args);
        storage.refreshFields();
    };

}

export default withPermissionContext(PrRetirementSavingsCompanyFormView);
